import React from 'react';
import '../styles/buttons.css';

const Button = ({ text, handleClick, type }) =>
  <a className={`btn ${type ? `btn--${type}` : ''}`} onClick={handleClick}>
    {text}
  </a>;

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.js